import React, {PropsWithChildren} from 'react';
import {Container, ContainerProvider} from '@yosmanyga/di';
import {IconsContextType, IconsProvider} from '@yosmanyga/rich-ui';
import {PrimitivesProvider} from '@yosmanyga/primitive-ui-spec';
import {WithLanguage} from './WithLanguage';

const AppWrapper = ({
    primitives,
    icons,
    container,
    children,
}: PropsWithChildren<{
    primitives: object;
    icons: IconsContextType;
    container: Container;
}>) => {
    return <ContainerProvider value={container}>
        <WithLanguage>
            <PrimitivesProvider value={primitives}>
                <IconsProvider value={icons}>
                    {children}
                </IconsProvider>
            </PrimitivesProvider>
        </WithLanguage>
    </ContainerProvider>
};

export {AppWrapper};
